import {
	Component,
	ContentChild,
	Input,
	TemplateRef
}               from '@angular/core';
import { ITag } from '@shared/components/tag/tag.model';

@Component( {
	selector: 'app-tag-item[tag]',
	templateUrl: './tag-item.component.html',
	styleUrls: [ './tag-item.component.scss' ]
} )
export class TagItemComponent {

	@Input() tag: ITag;
	@ContentChild( 'tagItemTpl', { read: TemplateRef } ) tagItemTpl: TemplateRef<any>;
}
